(function () {
  // Shopify's options[prefix]=last does nothing for Hebrew, but an explicit
  // trailing * wildcard does prefix-match Hebrew terms, so partial words like
  // "חולצ" find "חולצת ליב" products instead of returning 0 results.
  const finalToRegular = {
    ך: 'כ',
    ם: 'מ',
    ן: 'נ',
    ף: 'פ',
    ץ: 'צ',
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!action.split('?')[0].endsWith('/search')) return;

      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      let query = input.value.trim();
      if (!query) return;
      if (query.includes('"')) return;
      if (query.endsWith('*')) return;

      // Search does not normalize final-form letters: "אדומ*" misses products
      // titled "אדום", and "חולץ*" matches nothing while "חולצ*" matches every
      // "חולצה"/"חולצת". For a final-letter ending, OR the exact query with a
      // regular-form prefix so both exact and continued words are found. For
      // any other ending the prefix already includes the exact word.
      const lastChar = query.slice(-1);
      const regularForm = finalToRegular[lastChar];
      if (regularForm) {
        input.value = query + ' OR ' + query.slice(0, -1) + regularForm + '*';
      } else {
        input.value = query + '*';
      }
    },
    true
  );
})();
